import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=12d92470&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=12d92470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d92470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d92470')) {
      api.createRecord('12d92470', component.options)
    } else {
      api.reload('12d92470', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=12d92470&scoped=true&", function () {
      api.rerender('12d92470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8435DR4Gbw8yL/JS/comp/SearchFilterTokens.vue"
export default component.exports